import { Box, Button as MuiButton } from "@mui/material";
import { alpha, styled } from "@mui/material/styles";

interface IStyledButtonProps {
  active?: boolean;
  toolbar?: boolean;
}

export const StyledButton = styled(MuiButton, {
  shouldForwardProp: (prop) => prop !== "active" && prop !== "toolbar",
})<IStyledButtonProps>(({ theme, active, toolbar }) => {
  const isDark = theme.palette.mode === "dark";

  return {
    textTransform: "none",
    flexShrink: 0,
    height: 36,
    minHeight: 36,
    boxSizing: "border-box",
    paddingTop: 0,
    paddingBottom: 0,
    borderRadius: 999,
    border: `1px solid ${theme.palette.divider}`,
    color: theme.palette.text.primary,

    ...(active && {
      backgroundColor: theme.palette.text.primary,
      borderColor: theme.palette.text.primary,
      color: theme.palette.background.paper,

      "&:hover": {
        backgroundColor: theme.palette.text.primary,
        opacity: 0.9,
      },
    }),

    ...(toolbar && {
      height: 32,
      minHeight: 32,
      padding: theme.spacing(0, 1.625),
      fontSize: 13,
      fontWeight: 500,
      borderColor: alpha(theme.palette.divider, 0.08),
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.text.primary,

      "& svg": {
        fontSize: 16,
      },

      "& .FilterButton-chevron": {
        color: theme.palette.text.secondary,
      },

      "&:hover": {
        backgroundColor: isDark
          ? theme.palette.grey[900]
          : theme.palette.grey[50],
        borderColor: alpha(theme.palette.divider, 0.08),
        opacity: 1,
      },
    }),
  };
});

export const ButtonContent = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "0.35rem",
  fontSize: "inherit",
  fontWeight: 500,
});

export const TotalCount = styled("span")(({ theme }) => ({
  color: theme.palette.text.secondary,
}));

export const CountBadge = styled("span")(({ theme }) => ({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  minWidth: 18,
  height: 18,
  padding: "0 4px",
  borderRadius: 999,
  fontSize: 11,
  fontWeight: 600,
  backgroundColor: theme.palette.gold.main,
  color: theme.palette.gold.contrastText,
}));
